import { Translation } from '@ps/web-shared-components';
import React from 'react';

import StarsWizard from '@swf/components/StarsWizard/StarsWizard';

import Content from './Content';
import styles from './NewUser.scss';
import {
  TXTWCL_Chat_live_with_friends,
  TXTWCL_Enable_the_Webcam_Game_to_see__ELL
} from './Step3.messages.json';
import imagePNG from './assets/step3.png';
import image from './assets/step3.webp';

const Step3: React.FC = () => (
  <StarsWizard.Page name="Step3">
    <Content
      activePage={2}
      additionalText={
        <div className={styles.additionalText}>
          <Translation {...TXTWCL_Enable_the_Webcam_Game_to_see__ELL} />
        </div>
      }
      mainText={
        <div className={styles.mainText}>
          <Translation {...TXTWCL_Chat_live_with_friends} />
        </div>
      }
      pngImage={imagePNG}
      webPImage={image}
    />
  </StarsWizard.Page>
);

Step3.displayName = 'Step3';

export default Step3;
